import { createContext } from 'react';

const AssignmentContext = createContext({
  taken: false,
  setTaken: () => null,
  rejected: false,
  setRejected: () => null,
  url: '',
  setUrl: () => null,
});
export default AssignmentContext;
